import { render, staticRenderFns } from "./status.form.vue?vue&type=template&id=34736c4a&lang=pug"
import script from "./status.form.vue?vue&type=script&lang=js"
export * from "./status.form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports